/* =============================================
   ANBE Madrid - Delivery Date Calculator
   Calcula días hábiles (L-V) desde hoy
   ============================================= */
(function() {
  'use strict';

  const MONTHS = [
    'enero','febrero','marzo','abril','mayo','junio',
    'julio','agosto','septiembre','octubre','noviembre','diciembre'
  ];
  const DAYS = [
    'domingo','lunes','martes','miércoles',
    'jueves','viernes','sábado'
  ];

  // Festivos nacionales España (MM-DD)
  const HOLIDAYS = [
    '01-01','01-06','05-01','08-15',
    '10-12','11-01','12-06','12-08','12-25'
  ];

  function isHoliday(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return HOLIDAYS.includes(`${mm}-${dd}`);
  }

  function isWorkingDay(date) {
    const day = date.getDay(); // 0=dom, 6=sab
    return day !== 0 && day !== 6 && !isHoliday(date);
  }

  function addWorkingDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date)) added++;
    }
    return date;
  }

  function formatDate(date) {
    const dayName = DAYS[date.getDay()];
    const dayNum = date.getDate();
    const monthName = MONTHS[date.getMonth()];
    return `${dayName} ${dayNum} de ${monthName}`;
  }

  function renderDelivery() {
    // Buscar el contenedor donde inyectar la fecha
    const container = document.getElementById('anbe-delivery-date');
    if (!container) return;

    // Leer días del metafield (inyectado en el HTML via Liquid)
    const days = parseInt(container.dataset.days, 10);
    if (!days || isNaN(days) || days <= 0) {
      container.closest('.anbe-delivery-wrapper') && 
        (container.closest('.anbe-delivery-wrapper').style.display = 'none');
      return;
    }

    const today = new Date();
    // Si ya pasó la hora de corte (14:00), empezar desde mañana
    const cutoffHour = 14;
    const startDate = today.getHours() >= cutoffHour
      ? new Date(today.setDate(today.getDate() + 1))
      : new Date();

    const deliveryDate = addWorkingDays(startDate, days);
    const formatted = formatDate(deliveryDate);

    container.innerHTML = `Recíbelo gratis el <strong>${formatted}</strong>`;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderDelivery);
  } else {
    renderDelivery();
  }

})();